module.exports = __webpack_public_path__ + "img/heading_no.c537b9ff.svg";